export default __webpack_public_path__ + "751ac6bc9add11979ba60f2cd563663c.png";